module.exports = __webpack_public_path__ + "42cb825326011a829d84cb7c315feb8d.fbx";